// extracted by mini-css-extract-plugin
module.exports = {"load-more":"LoadMoreButton_load-more__g7WhB","load-more__text":"LoadMoreButton_load-more__text__Ujdxu","load-more__icon":"LoadMoreButton_load-more__icon__xQLC5"};